module.exports = __webpack_public_path__ + "img/security-img.3b0967d1.png";